import React, { Component } from 'react';

import { Table, ButtonToolbar, Button, Grid, Row, Col, Form, FormGroup, ControlLabel, Checkbox, FormControl } from 'react-bootstrap';
import { Stage, Layer, Group, Rect, Line, Text } from 'react-konva';
import Select from "react-select";

import { SetOfDayTypesCommand } from '../../commands/SetOfDayTypesCommand';
import { HandleMessage } from '../../../HandleMessage';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { PaginationBuilder } from '../../../PaginationBuilder';
import { PaginationHelper } from '../../../helpers/PaginationHelper';
import { TableButton } from '../../../TableButton';
import { SelectOptionsHelper } from '../../../helpers/SelectOptionsHelper';

export class VerticalTabularDayTimesheetDataIdentifier extends Component {
    constructor(props) {
        super(props);

        let tabularDayTimesheetConfiguration = {
            showOnlyInSpineStops: false,
            hideNonInSpineStops: false,
            hidePreviousStops: false,
            hideZoneLimitStops: false,
            hideStopsWithMapPoint: false,
            shrinkText: false,
            showStopCaps: false,
            showStopCode: false,
            stopCodePrecendentText: "",
            stopCodeSubsequentText: "",
            split: 0,
            showFirstSplit: true,
            showLastSplit: true,
            showEmptySplit: true,
            emptyPassing: 0,
            zonesBackgroundBuilderComponent: 0
        };
        try {
            tabularDayTimesheetConfiguration = Object.assign(tabularDayTimesheetConfiguration, JSON.parse(props.configuration));
        }
        catch (_) { }

        this.state = {
            selectedData: props.selectedData,
            configuration: props.configuration,
            table: {
                data: [],
                page: 1,
                elementsPerPage: 10
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            },
            form: {
                id: props.selectedData,
                showOnlyInSpineStops: tabularDayTimesheetConfiguration.showOnlyInSpineStops,
                hideNonInSpineStops: tabularDayTimesheetConfiguration.hideNonInSpineStops,
                hidePreviousStops: tabularDayTimesheetConfiguration.hidePreviousStops,
                hideZoneLimitStops: tabularDayTimesheetConfiguration.hideZoneLimitStops,
                hideStopsWithMapPoint: tabularDayTimesheetConfiguration.hideStopsWithMapPoint,
                shrinkText: tabularDayTimesheetConfiguration.shrinkText,
                showStopCaps: tabularDayTimesheetConfiguration.showStopCaps,
                showStopCode: tabularDayTimesheetConfiguration.showStopCode,
                stopCodePrecendentText: tabularDayTimesheetConfiguration.stopCodePrecendentText,
                stopCodeSubsequentText: tabularDayTimesheetConfiguration.stopCodeSubsequentText,
                split: tabularDayTimesheetConfiguration.split,
                showFirstSplit: tabularDayTimesheetConfiguration.showFirstSplit,
                showLastSplit: tabularDayTimesheetConfiguration.showLastSplit,
                showEmptySplit: tabularDayTimesheetConfiguration.showEmptySplit,
                emptyPassing: tabularDayTimesheetConfiguration.emptyPassing,
                zonesBackgroundBuilderComponent: tabularDayTimesheetConfiguration.zonesBackgroundBuilderComponent,
            },
            actions: {
                isLoading: true
            }
        };

        this.getAllData(false);
    }

    getAllData(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoading = true;

            this.setState({
                table: {
                    data: [],
                    page: 1,
                    elementsPerPage: 10
                },
                actions: actions
            });
        }

        const setOfDayTypesCommand = new SetOfDayTypesCommand();
        setOfDayTypesCommand.list(
            (a) => this.successCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    // ---------------------------

    successCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    errorCallback(message) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.page = 1;
        table.data = [];

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    // -----------------------

    onSelectData(data) {
        const { form } = this.state;

        form.id = `${data.id}`;

        this.setState({
            form: form
        });
    }

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    onChangeSelectValue(e, target) {
        const { form } = this.state;

        form[target] = e;

        this.setState({
            form: form
        });
    }

    onChangeValue(e, target) {
        const { form } = this.state;

        form[target] = e.target.value;

        this.setState({
            form: form
        });
    }

    onFinishSelectData() {
        const { form } = this.state;

        const data = `${form.id}`;
        const configuration = {
            showOnlyInSpineStops: form.showOnlyInSpineStops,
            hideNonInSpineStops: form.hideNonInSpineStops,
            hidePreviousStops: form.hidePreviousStops,
            hideZoneLimitStops: form.hideZoneLimitStops,
            hideStopsWithMapPoint: form.hideStopsWithMapPoint,
            shrinkText: form.shrinkText,
            showStopCaps: form.showStopCaps,
            showStopCode: form.showStopCode,
            stopCodePrecendentText: form.stopCodePrecendentText,
            stopCodeSubsequentText: form.stopCodeSubsequentText,
            split: form.split,
            showFirstSplit: form.showFirstSplit,
            showLastSplit: form.showLastSplit,
            showEmptySplit: form.showEmptySplit,
            emptyPassing: form.emptyPassing,
            zonesBackgroundBuilderComponent: form.zonesBackgroundBuilderComponent,
        };

        this.props.onSelectData(data);
        this.props.onConfigureData(JSON.stringify(configuration), true);
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // -----------------------

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSelectedDataButton(obj) {
        const { form } = this.state;

        if (`${obj.id}` === form.id) {
            return (
                <TableButton icon="icon-ok" title="Selecionado" />
            );
        }

        return (
            <TableButton icon="icon-select" title="Selecionar" onClick={() => this.onSelectData(obj)} />
        );
    }

    renderHideStrategiesForm(form) {
        if (form.showOnlyInSpineStops) {
            return null;
        }

        return (
            <div>
                <ControlLabel className="margin-top-15">Estratégias para esconder paragens (caso necessário)</ControlLabel>
                <Checkbox checked={form.hideNonInSpineStops}
                    onChange={() => this.onChangeCheckboxValue("hideNonInSpineStops")}>
                    Esconder paragens não configuradas como presentes na espinha
                </Checkbox>
                <Checkbox checked={form.hidePreviousStops}
                    onChange={() => this.onChangeCheckboxValue("hidePreviousStops")}>
                    Esconder paragens anterior à paragem alvo
                </Checkbox>
                <Checkbox checked={form.shrinkText}
                    onChange={() => this.onChangeCheckboxValue("shrinkText")}>
                    Ajustar tamanho do texto no caso de não caber nas dimensões especificadas
                </Checkbox>

                <ControlLabel className="margin-top-15">Opções</ControlLabel>
                <Checkbox checked={form.hideZoneLimitStops}
                    onChange={() => this.onChangeCheckboxValue("hideZoneLimitStops")}>
                    Permitir esconder paragens limites de zona
                </Checkbox>
                <Checkbox checked={form.hideStopsWithMapPoint}
                    onChange={() => this.onChangeCheckboxValue("hideStopsWithMapPoint")}>
                    Permitir esconder paragens que pertençam a um ponto notável
                </Checkbox>
            </div>
        );
    }

    renderStopTextConfigurationsForm(form) {
        return (
            <div>
                <FormGroup>
                    <ControlLabel className="margin-top-15">Confiração da Apresentação do Nome da Paragem</ControlLabel>
                    <Checkbox checked={form.showStopCaps}
                        onChange={() => this.onChangeCheckboxValue("showStopCaps")}>
                        Apresentar Paragens em Maiúsculas
                    </Checkbox>
                    <Checkbox checked={form.showStopCode}
                        onChange={() => this.onChangeCheckboxValue("showStopCode")}>
                        Mostrar Código da Paragem
                    </Checkbox>
                </FormGroup>

                {this.renderStopCodePrecedentAndSubsequentTextForm(form)}
            </div>
        );
    }

    renderStopCodePrecedentAndSubsequentTextForm(form) {
        if (!form.showStopCode) {
            return null;
        }

        return (
            <FormGroup>
                <ControlLabel className="margin-top-15">Texto Precedente ao Código da Paragem</ControlLabel>
                <FormControl
                    type="text"
                    value={form.stopCodePrecendentText}
                    onChange={(e) => this.onChangeValue(e, "stopCodePrecendentText")} />

                <ControlLabel className="margin-top-15">Texto Subsequente ao Código da Paragem</ControlLabel>
                <FormControl
                    type="text"
                    value={form.stopCodeSubsequentText}
                    onChange={(e) => this.onChangeValue(e, "stopCodeSubsequentText")} />
            </FormGroup>
        );
    }

    renderSplitLayoutsForm(form) {
        return (
            <FormGroup>
                <ControlLabel className="margin-top-15">Configuração do Separador de Viagens</ControlLabel>
                <Select options={SelectOptionsHelper.TabularComponentsSplitTypesOptions}
                    placeholder="Tipos de Separadores de Viagens"
                    isClearable={false}
                    onChange={(e) => this.onChangeSelectValue(e.value, "split")}
                    isOptionSelected={function (a) {
                        return form.split === a.value;
                    }}
                    value={SelectOptionsHelper.TabularComponentsSplitTypesOptions.find(option => option.value === form.split)} />
                <Checkbox checked={form.showFirstSplit} disabled={0 === form.split}
                    onChange={() => this.onChangeCheckboxValue("showFirstSplit")}>
                    Mostrar primeiro separador de viagens
                </Checkbox>
                <Checkbox checked={form.showLastSplit} disabled={0 === form.split}
                    onChange={() => this.onChangeCheckboxValue("showLastSplit")}>
                    Mostrar último separador de viagens
                </Checkbox>
                <Checkbox checked={form.showEmptySplit} disabled={0 === form.split}
                    onChange={() => this.onChangeCheckboxValue("showEmptySplit")}>
                    Mostrar separador de viagens vazias
                </Checkbox>
            </FormGroup>
        );
    }

    renderNoTimesForm(form) {
        return (
            <FormGroup>
                <ControlLabel className="margin-top-15">Configuração de Tempos de Passagem Vazios</ControlLabel>
                <Select options={SelectOptionsHelper.TabularComponentsNoTimesOptions}
                    placeholder="Tipos de Tempos de Passagem Vazios"
                    isClearable={false}
                    onChange={(e) => this.onChangeSelectValue(e.value, "emptyPassing")}
                    isOptionSelected={function (a) {
                        return form.emptyPassing === a.value;
                    }}
                    value={SelectOptionsHelper.TabularComponentsNoTimesOptions.find(option => option.value === form.emptyPassing)} />
            </FormGroup>
        );
    }

    renderBarsLayouts(barBuilderComponent, target) {
        return (
            <Grid fluid>
                <Row>
                    <Col md={4} sm={6} xs={12}>
                        <Stage width={260}
                            height={60}
                            style={{ cursor: "pointer" }}>
                            <Layer>
                                <Group onClick={() => this.onChangeSelectValue(0, target)}>
                                    <Rect x={5}
                                        y={5}
                                        width={250}
                                        height={50}
                                        strokeWidth={undefined === barBuilderComponent || 0 === barBuilderComponent ? 3 : 1}
                                        stroke={undefined === barBuilderComponent || 0 === barBuilderComponent ? "#6699ff" : "#4d4d4d"}
                                        fill="#FFFFFF" />

                                    <Rect x={15}
                                        y={20}
                                        width={115}
                                        height={20}
                                        strokeWidth={1}
                                        stroke={"black"}
                                        fill="#FFFFFF" />
                                    <Rect x={130}
                                        y={20}
                                        width={115}
                                        height={20}
                                        strokeWidth={1}
                                        stroke={"black"}
                                        fill="#FFFFFF" />

                                    <Text text="Zona A"
                                        fontSize={14}
                                        x={55}
                                        y={25} />
                                    <Text text="Zona B"
                                        fontSize={14}
                                        x={170}
                                        y={25} />
                                </Group>
                            </Layer>
                        </Stage>
                    </Col>

                    <Col md={4} sm={6} xs={12}>
                        <Stage width={260}
                            height={60}
                            style={{ cursor: "pointer" }}>
                            <Layer>
                                <Group onClick={() => this.onChangeSelectValue(1, target)}>
                                    <Rect x={5}
                                        y={5}
                                        width={250}
                                        height={50}
                                        strokeWidth={1 === barBuilderComponent ? 3 : 1}
                                        stroke={1 === barBuilderComponent ? "#6699ff" : "#4d4d4d"}
                                        fill="#FFFFFF" />

                                    <Line
                                        x={15}
                                        y={20}
                                        points={[0, 0, 0, 20]}
                                        stroke="black"
                                        strokeWidth={1} />
                                    <Line
                                        x={15}
                                        y={40}
                                        points={[0, 0, 113, 0]}
                                        stroke="black"
                                        strokeWidth={1} />

                                    <Line
                                        x={132}
                                        y={20}
                                        points={[0, 0, 0, 20]}
                                        stroke="black"
                                        strokeWidth={1} />
                                    <Line
                                        x={132}
                                        y={40}
                                        points={[0, 0, 113, 0]}
                                        stroke="black"
                                        strokeWidth={1} />

                                    <Text text="Zona A"
                                        fontSize={14}
                                        x={55}
                                        y={25} />
                                    <Text text="Zona B"
                                        fontSize={14}
                                        x={170}
                                        y={25} />
                                </Group>
                            </Layer>
                        </Stage>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderZonesBarConfigurationsForm(form) {
        return (
            <FormGroup>
                <ControlLabel className="margin-top-15">Barra da Zona</ControlLabel>
                {this.renderBarsLayouts(form.zonesBackgroundBuilderComponent, "zonesBackgroundBuilderComponent")}
            </FormGroup>
        );
    }

    render() {
        const { isLoading } = this.state.actions;

        const { table, form, message } = this.state;
        const partialData = table.data.slice((table.page - 1) * table.elementsPerPage, table.page * table.elementsPerPage);

        return (
            <div>
                <Grid fluid className="table-small-screens">
                    <div className="table-loading">
                        <Table responsive striped hover style={{ marginTop: 10 }} className={isLoading ? "overlay" : ""}>
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    partialData.map((obj, idx) =>
                                        <tr key={`data-${idx}`}>
                                            <td>{obj.name}</td>
                                            <td>{this.renderSelectedDataButton(obj)}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>

                        <PaginationBuilder
                            currentPage={table.page}
                            elementsPerPage={table.elementsPerPage}
                            dataLength={table.data.length}
                            onChangePage={(a) => this.onChangePage(a)}
                            onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />

                        {this.renderLoading(isLoading)}
                    </div>
                </Grid>

                <Form>
                    <FormGroup
                        bsSize="small"
                        controlId="formDataHideStopStrategies" >
                        <ControlLabel>Estratégias para mostrar paragens</ControlLabel>
                        <Checkbox checked={form.showOnlyInSpineStops}
                            onChange={() => this.onChangeCheckboxValue("showOnlyInSpineStops")}>
                            Apenas paragens configuradas como presentes na espinha
                        </Checkbox>

                        {this.renderHideStrategiesForm(form)}
                    </FormGroup>

                    {this.renderStopTextConfigurationsForm(form)}
                    {this.renderSplitLayoutsForm(form)}
                    {this.renderNoTimesForm(form)}
                    {this.renderZonesBarConfigurationsForm(form)}
                </Form>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.onFinishSelectData()}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/VerticalTabularDayTimesheetDataIdentifier.js